export const PAGE_LOAD_ERROR = 'PAGE_LOAD_ERROR';
export const PAGE_LOAD_START = 'PAGE_LOAD_START';
export const PAGE_LOAD_SUCCESS = 'PAGE_LOAD_SUCCESS';
export const PAGE_LOAD_ERROR_CLEAR = 'PAGE_LOAD_ERROR_CLEAR';
